// import { allBooksCategories } from "../../../data/CategoriesData"
import { BookDataModify } from "./components/BookDataModify";
import { AddBooks } from "../../library/AddBooks";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from "@fortawesome/free-solid-svg-icons";
import { useAdminBooks } from '../../../context/Admins/AdminBooksContext';
import { useAdminLibCategory } from '../../../context/Admins/AdminLibCategoryContext';

import Pagination from "../../../utilities/Pagination";
import 'moment/locale/ar'
import BookSampleImg from "../../../assets/defaults/BookSample-1.png"

export function SettingBooks() {
    const { allCategories } = useAdminLibCategory();

    const { selectedCategory, setSelectedCategory,
        settingBooks, currentPage, setCurrentPage,
        searchQuery, setSearchQuery } = useAdminBooks();
    // const [error, setError] = useState(null);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };
    const filteredBooksData = settingBooks?.data?.result.filter(item =>
        item.title.includes(searchQuery) ||
        item.author.includes(searchQuery) ||
        item.publishedDate.toString().includes(searchQuery)
    );
    const totalPages = settingBooks?.data?.paginationInfo.totalPagesCount;

    const BookSample = ({ id, title, img, imgAlt, addDate, price, description, qty, available, author, pubYear, bookCategory, bookCategoryId, pages }) => (
        <div className="book-container col-6 col-lg-3 my-1 px-1" >
            {/* {!selectedBook && */}
            {qty < 1 ? <FontAwesomeIcon icon={faBan} className="fs-1 position-absolute top-50 start-50 translate-middle text-warning text-opacity-50 bg-white w-75 h-100 bg-opacity-50 rounded" /> : ""}
            <img
                crossOrigin="anonymous"
                src={img ? img : BookSampleImg}
                alt={imgAlt}
                className="rounded-2 w-100"
                data-bs-toggle="modal"
                data-bs-target={`#book-edit${id}`}

            />
            <div className="book-title p-1 rounded mb-2">
                <p>{title}</p>
            </div>

            {/* </Link> */}
            <BookDataModify
                title={title}
                id={id}
                img={img}
                imgAlt={imgAlt}
                addDate={addDate}
                price={price}
                description={description}
                qty={qty}
                available={available}
                author={author}
                pubYear={pubYear}
                bookCategory={bookCategory}
                bookCategoryId={bookCategoryId}
                pages={pages}
                BookSampleImg={BookSampleImg}
            />
            {/* </> */}
            {/* } */}
        </div>
    );

    // if (error) return <div className="text-center my-4 text-danger">{error}</div>;
    if (!settingBooks) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;

    return (<>
        <div className="container my-3 rounded bg-light-gray position-relative p-3 pb-5">
            <div className='d-flex flex-wrap justify-content-between'>
                <select className="form-select form-select-sm w-auto mb-2" aria-label="books-category"
                    onChange={e => {
                        setSelectedCategory(e.target.value);
                    }}
                    defaultValue={selectedCategory}>
                    <option value="">الكل</option>
                    {allCategories
                        .sort((a, b) => a.id - b.id)
                        .map((category) =>
                            <option key={category.id}
                                value={category.id}>
                                {category.nameAr}</option>
                        )}
                </select>
                <input
                    name="queryBooks"
                    className="form-control-sm border my-2 col-9 col-md-4"
                    type="search"
                    placeholder={
                        selectedCategory
                            ? `البحث في التصنيف`
                            : `البحث باسم المؤلف / الكتاب / سنة النشر`
                    }
                    value={searchQuery}
                    onChange={handleSearchChange} />
                <div className="btn-masar d-flex justify-content-center align-items-center rounded-2 bg-white m-2 mt-0 fs-3 p-0 c-darkGray col-2"
                    data-bs-toggle="modal"
                    data-bs-target="#add-book">
                    +
                </div>
            </div>
            <div className="d-flex flex-wrap justify-content-center justify-content-md-start">
                {(searchQuery ?
                    (filteredBooksData)
                    : (settingBooks?.data?.result)).map((data) => (
                        <BookSample
                            key={data.id}
                            id={data.id}
                            title={data.title}
                            img={data.thumbnail}
                            imgAlt={`book_${data.id}`}
                            addDate={data.createdAt}
                            price={data.price}
                            description={data.description}
                            qty={data.quantity}
                            available={data.available}
                            author={data.author}
                            pubYear={data.publishedDate}
                            bookCategory={data.category.nameAr}
                            bookCategoryId={data.category.id}
                            pages={data.numberOfPages} />
                    ))}
            </div>
            {totalPages > 1 &&
                <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={totalPages} />
            }
        </div>

        <AddBooks />
    </>
    )
}